import { Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { FC } from "react";

import IdValidation from "../../components/dynamicEditor/components/idValidation";

const IdValidationTab: FC = () => {
	const component = { label: undefined, disabled: false } as any;
	return (
		<Card>
			<CardHeader>
				<CardTitle>ID Validation</CardTitle>
			</CardHeader>
			<CardContent>
				<IdValidation {...({ component } as any)} />
			</CardContent>
		</Card>
	);
};

export default IdValidationTab;
